export default __webpack_public_path__ + "static/media/screens-bg.c7ef706d.svg";